import { queryParams, type RouteQueryOptions, type RouteDefinition, type RouteFormDefinition, applyUrlDefaults } from './../../../wayfinder'
import test from './test'
import probe from './probe'
import widgetMonitorFed418 from './widget-monitor'
import cronWorker from './cron-worker'
/**
* @see \App\Http\Controllers\Admin\Platform\SystemController::index
* @see app/Http/Controllers/Admin/Platform/SystemController.php:59
* @route '/settings/system'
*/
export const index = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: index.url(options),
    method: 'get',
})

index.definition = {
    methods: ["get","head"],
    url: '/settings/system',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Admin\Platform\SystemController::index
* @see app/Http/Controllers/Admin/Platform/SystemController.php:59
* @route '/settings/system'
*/
index.url = (options?: RouteQueryOptions) => {
    return index.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Admin\Platform\SystemController::index
* @see app/Http/Controllers/Admin/Platform/SystemController.php:59
* @route '/settings/system'
*/
index.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: index.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Admin\Platform\SystemController::index
* @see app/Http/Controllers/Admin/Platform/SystemController.php:59
* @route '/settings/system'
*/
index.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: index.url(options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\Admin\Platform\SystemController::index
* @see app/Http/Controllers/Admin/Platform/SystemController.php:59
* @route '/settings/system'
*/
const indexForm = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: index.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Admin\Platform\SystemController::index
* @see app/Http/Controllers/Admin/Platform/SystemController.php:59
* @route '/settings/system'
*/
indexForm.get = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: index.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Admin\Platform\SystemController::index
* @see app/Http/Controllers/Admin/Platform/SystemController.php:59
* @route '/settings/system'
*/
indexForm.head = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: index.url({
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

index.form = indexForm

/**
* @see \App\Http\Controllers\Admin\Platform\SystemController::update
* @see app/Http/Controllers/Admin/Platform/SystemController.php:202
* @route '/settings/system/{section}'
*/
export const update = (args: { section: string | number } | [section: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'patch'> => ({
    url: update.url(args, options),
    method: 'patch',
})

update.definition = {
    methods: ["patch"],
    url: '/settings/system/{section}',
} satisfies RouteDefinition<["patch"]>

/**
* @see \App\Http\Controllers\Admin\Platform\SystemController::update
* @see app/Http/Controllers/Admin/Platform/SystemController.php:202
* @route '/settings/system/{section}'
*/
update.url = (args: { section: string | number } | [section: string | number ] | string | number, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { section: args }
    }

    if (Array.isArray(args)) {
        args = {
            section: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        section: args.section,
    }

    return update.definition.url
            .replace('{section}', parsedArgs.section.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Admin\Platform\SystemController::update
* @see app/Http/Controllers/Admin/Platform/SystemController.php:202
* @route '/settings/system/{section}'
*/
update.patch = (args: { section: string | number } | [section: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'patch'> => ({
    url: update.url(args, options),
    method: 'patch',
})

/**
* @see \App\Http\Controllers\Admin\Platform\SystemController::update
* @see app/Http/Controllers/Admin/Platform/SystemController.php:202
* @route '/settings/system/{section}'
*/
const updateForm = (args: { section: string | number } | [section: string | number ] | string | number, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: update.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'PATCH',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Admin\Platform\SystemController::update
* @see app/Http/Controllers/Admin/Platform/SystemController.php:202
* @route '/settings/system/{section}'
*/
updateForm.patch = (args: { section: string | number } | [section: string | number ] | string | number, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: update.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'PATCH',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'post',
})

update.form = updateForm

/**
* @see \App\Http\Controllers\Admin\Platform\HotPathLatencyController::hotpathLatency
* @see app/Http/Controllers/Admin/Platform/HotPathLatencyController.php:25
* @route '/settings/system/hotpath-latency'
*/
export const hotpathLatency = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: hotpathLatency.url(options),
    method: 'get',
})

hotpathLatency.definition = {
    methods: ["get","head"],
    url: '/settings/system/hotpath-latency',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Admin\Platform\HotPathLatencyController::hotpathLatency
* @see app/Http/Controllers/Admin/Platform/HotPathLatencyController.php:25
* @route '/settings/system/hotpath-latency'
*/
hotpathLatency.url = (options?: RouteQueryOptions) => {
    return hotpathLatency.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Admin\Platform\HotPathLatencyController::hotpathLatency
* @see app/Http/Controllers/Admin/Platform/HotPathLatencyController.php:25
* @route '/settings/system/hotpath-latency'
*/
hotpathLatency.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: hotpathLatency.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Admin\Platform\HotPathLatencyController::hotpathLatency
* @see app/Http/Controllers/Admin/Platform/HotPathLatencyController.php:25
* @route '/settings/system/hotpath-latency'
*/
hotpathLatency.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: hotpathLatency.url(options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\Admin\Platform\HotPathLatencyController::hotpathLatency
* @see app/Http/Controllers/Admin/Platform/HotPathLatencyController.php:25
* @route '/settings/system/hotpath-latency'
*/
const hotpathLatencyForm = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: hotpathLatency.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Admin\Platform\HotPathLatencyController::hotpathLatency
* @see app/Http/Controllers/Admin/Platform/HotPathLatencyController.php:25
* @route '/settings/system/hotpath-latency'
*/
hotpathLatencyForm.get = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: hotpathLatency.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Admin\Platform\HotPathLatencyController::hotpathLatency
* @see app/Http/Controllers/Admin/Platform/HotPathLatencyController.php:25
* @route '/settings/system/hotpath-latency'
*/
hotpathLatencyForm.head = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: hotpathLatency.url({
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

hotpathLatency.form = hotpathLatencyForm

/**
* @see \App\Http\Controllers\Admin\Platform\WidgetMonitorController::widgetMonitor
* @see app/Http/Controllers/Admin/Platform/WidgetMonitorController.php:36
* @route '/settings/system/widget-monitor'
*/
export const widgetMonitor = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: widgetMonitor.url(options),
    method: 'get',
})

widgetMonitor.definition = {
    methods: ["get","head"],
    url: '/settings/system/widget-monitor',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Admin\Platform\WidgetMonitorController::widgetMonitor
* @see app/Http/Controllers/Admin/Platform/WidgetMonitorController.php:36
* @route '/settings/system/widget-monitor'
*/
widgetMonitor.url = (options?: RouteQueryOptions) => {
    return widgetMonitor.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Admin\Platform\WidgetMonitorController::widgetMonitor
* @see app/Http/Controllers/Admin/Platform/WidgetMonitorController.php:36
* @route '/settings/system/widget-monitor'
*/
widgetMonitor.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: widgetMonitor.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Admin\Platform\WidgetMonitorController::widgetMonitor
* @see app/Http/Controllers/Admin/Platform/WidgetMonitorController.php:36
* @route '/settings/system/widget-monitor'
*/
widgetMonitor.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: widgetMonitor.url(options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\Admin\Platform\WidgetMonitorController::widgetMonitor
* @see app/Http/Controllers/Admin/Platform/WidgetMonitorController.php:36
* @route '/settings/system/widget-monitor'
*/
const widgetMonitorForm = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: widgetMonitor.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Admin\Platform\WidgetMonitorController::widgetMonitor
* @see app/Http/Controllers/Admin/Platform/WidgetMonitorController.php:36
* @route '/settings/system/widget-monitor'
*/
widgetMonitorForm.get = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: widgetMonitor.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Admin\Platform\WidgetMonitorController::widgetMonitor
* @see app/Http/Controllers/Admin/Platform/WidgetMonitorController.php:36
* @route '/settings/system/widget-monitor'
*/
widgetMonitorForm.head = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: widgetMonitor.url({
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

widgetMonitor.form = widgetMonitorForm

const system = {
    index: Object.assign(index, index),
    update: Object.assign(update, update),
    test: Object.assign(test, test),
    probe: Object.assign(probe, probe),
    hotpathLatency: Object.assign(hotpathLatency, hotpathLatency),
    widgetMonitor: Object.assign(widgetMonitor, widgetMonitorFed418),
    cronWorker: Object.assign(cronWorker, cronWorker),
}

export default system